import React, { Component } from 'react'

export default class Department extends Component {
    render() {
        return (
            <div>
                Department will be shown here :)
            </div>
        )
    }
}
